import { MenuBookDataType, MenuInfoDataType } from 'apis/types';

export function filterOutTakeoutMenubooks(
  menuInfo: MenuInfoDataType,
  menubook: MenuBookDataType
): { menuInfo: MenuInfoDataType; menubook: MenuBookDataType } {
  const takeoutIds = new Set<string>();
  Object.keys(menubook).forEach((key) => {
    if (menubook[key]?.sales_channel === '1') {
      takeoutIds.add(menubook[key].menubook_id);
    }
  });

  const filteredMenubook: MenuBookDataType = {};
  Object.keys(menubook).forEach((key) => {
    if (menubook[key]?.sales_channel !== '1') {
      filteredMenubook[key] = menubook[key];
    }
  });

  const filteredMenuInfo: MenuInfoDataType = {
    ...menuInfo,
    menubook: menuInfo.menubook.filter((item) => !takeoutIds.has(item.menubook_id)),
  };

  return { menuInfo: filteredMenuInfo, menubook: filteredMenubook };
}
